/* eslint-disable camelcase */
export default {
	actionsButton: "Actions",
	transcribeButton: "Transcribe Recording",
	meetingAssistantButton: "Add meeting assistant",
	meetingAssistantSaveButton: "Save",
	meetingAssistantCancelButton: "Cancel",

	editNoteNameMenuItem: "Edit note name",
	editDateAndTimeMenuItem: "Edit date & time",
	editDisabled: "Opre was invited to this meeting via a calendar email. Please edit the event in your calendar, and Opre will sync your changes.",
	saveAsTemplateMenuItem: "Save as template",
	copyLinkToNoteMenuItem: "Copy link to note",
	deleteNoteMenuItem: "Delete note",
	transcribeMenuItem: "Transcribe from recording",
	addAssistantMenuItem: "Add Opre Assistant",
	scheduleRecurrenceMenuItem: "Repeat this meeting",
};
